import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const CourseCardSkeleton = ({ className }: { className?: string }): ReactNode => (
  <Skeleton className={`h-[200px] rounded-2xl ${className}`} />
)

export const CourseCardsSkeleton = (): ReactNode => {
  return (
    <>
      <CourseCardSkeleton />
      <CourseCardSkeleton />
      <CourseCardSkeleton />
    </>
  )
}
